import { workspaceLogoOf } from '@/hooks/use-workspace-logo'
import { useWorkspaceStore } from '@/stores/workspace-store'

/**
 * The customer's logo for a preview inside the app: the one e-mail to their people carries (the workspace's own, else its company's),
 * absolute, or null when there is none or the workspace list has not arrived.
 *
 * Read when a preview is drawn, not subscribed: previews are built by plain functions, called from some thirty places, none of which
 * has a reason to know. Only for a logo that IS the customer's: a generic slug, or a token that always means the employer. A lure can
 * imitate a third party, and a preview of that must never take this logo.
 */
export function tenantPreviewLogo(): string | null {
  const { workspaces, activeWorkspaceId } = useWorkspaceStore.getState()
  return workspaceLogoOf(workspaces, activeWorkspaceId)
}
